module.exports = "<div id=\"home-page\">\n  <img [src]=\"'/assets/img/' + images[selected]\" />\n  <h2>Orfèvre à Paris<br/>depuis 1857</h2>\n</div>\n"